import Group683 from 'assets/shared/Group683.svg';
import Group684 from 'assets/shared/Group684.svg';
import LoginCards from 'assets/shared/Login_Cards.svg';

export const BannerSteps = [
    {
        src: LoginCards,
        textSecondary: 'Introducing',
        textPrimary: 'Paystand Spend',
        textDescription: 'Your full stack spend management solution with Bitcoin rewards and advanced spend controls.'
    },
    {
        src: Group683,
        textSecondary: 'Peace of mind for you',
        textPrimary: 'Speed & Flexibility',
        textDescription: 'Instantly create virtual and physical cards and track transactions by class and category in real-time.'
    },
    {
        src: Group684,
        textSecondary: 'Earn More from your rewards',
        textPrimary: 'Cash Back in Bitcoin',
        textDescription: 'Earn bitcoin points on every dollar you spend.'
    }
];
